import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../assets/filter/box-open.svg'


const _withScopeId = n => (_pushScopeId("data-v-4446105e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between align-items-center mb-7" }
const _hoisted_2 = { class: "d-flex flex-row gap-4 w-75" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  style: {"height":"fit-content","width":"fit-content","font-size":"20px"},
  class: "m-0 fas fa-arrow-left"
}, null, -1))
const _hoisted_4 = { class: "col-12 d-flex flex-column p-0" }
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<li style=\"background:#203972;border-radius:10px 10px 0px 0px;\" class=\"col-12 p-4 d-flex flex-row\" data-v-4446105e><span class=\"text-white subtitulo col-4 d-flex justify-content-start\" data-v-4446105e>Loja</span><span class=\"text-white subtitulo col-2 d-flex justify-content-start\" data-v-4446105e>Plano</span><span class=\"text-white subtitulo col-1 d-flex justify-content-start\" data-v-4446105e>Status</span><span class=\"text-white subtitulo col-3 d-flex justify-content-center\" data-v-4446105e>Data</span><span class=\"text-white subtitulo col-2 d-flex justify-content-end pe-10\" data-v-4446105e>Ação</span></li>", 1)
const _hoisted_6 = {
  key: 0,
  class: "d-flex w-100 flex-column bg-white",
  style: {"border-radius":"0 0 10px 10px"}
}
const _hoisted_7 = { class: "col-4 d-flex justify-content-start ps-3" }
const _hoisted_8 = { class: "col-2 d-flex justify-content-start ps-3" }
const _hoisted_9 = { class: "col-1 d-flex justify-content-start ps-3" }
const _hoisted_10 = { class: "col-3 d-flex justify-content-center ps-3" }
const _hoisted_11 = { class: "col-2 d-flex justify-content-end pe-6" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = {
  key: 2,
  class: "card d-flex h-100 justify-content-center",
  id: "empty"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { style: {"color":"rgb(213 202 202)"} }, "Nenhuma loja para ser exibida.", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "m-5",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Title = _resolveComponent("Title")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Button = _resolveComponent("Button")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_Pagination = _resolveComponent("Pagination")!
  const _component_ModalEditPlanoLojaVue = _resolveComponent("ModalEditPlanoLojaVue")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Title, null, {
        default: _withCtx(() => [
          _createTextVNode("Planos")
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_input, {
          placeholder: "Pesquise por loja",
          clearable: "",
          modelValue: _ctx.paramsFilter.nomeFantasia,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paramsFilter.nomeFantasia) = $event))
        }, null, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          modelValue: _ctx.paramsFilter.codConcessionaria,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.paramsFilter.codConcessionaria) = $event)),
          placeholder: "Loja",
          clearable: "",
          filterable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.lojasSelect, (loja, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: loja.nomeFantasia,
                value: loja.codConcessionaria,
                key: key
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_el_select, {
          modelValue: _ctx.paramsFilter.idPlano,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.paramsFilter.idPlano) = $event)),
          placeholder: "Plano",
          clearable: "",
          filterable: ""
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.planosSelect, (plano, key) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                label: plano.nome,
                value: plano.id,
                key: key
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_router_link, {
          to: "/lojas",
          style: {"height":"fit-content","white-space":"nowrap"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Button, { text: "Voltar" }, {
              default: _withCtx(() => [
                _hoisted_3
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("ul", _hoisted_4, [
      _hoisted_5,
      (_ctx.skeleton)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_el_skeleton, {
              animated: "",
              rows: 13,
              class: "text-center p-5 d-block"
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.skeleton && _ctx.lojasWithPlans.length)
        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.lojasWithPlans, (loja, key) => {
            return (_openBlock(), _createElementBlock("li", {
              class: "listaZebra col-12 d-flex flex-row align-items-center p-2",
              style: {"background":"#ffff"},
              key: key
            }, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(loja.nomeFantasia), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(loja.nome), 1),
              _createElementVNode("div", _hoisted_9, _toDisplayString(loja.status), 1),
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.formatarDataParaTemplate(loja.dataInicio)) + " a " + _toDisplayString(_ctx.formatarDataParaTemplate(loja.dataFim)), 1),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  class: "btn btn-danger btn-sm",
                  onClick: ($event: any) => (_ctx.clickedLojaPlan(loja.id), _ctx.openModal('ModalEditPlanoLoja'))
                }, "Editar", 8, _hoisted_12)
              ])
            ]))
          }), 128))
        : _createCommentVNode("", true),
      (!_ctx.skeleton && !_ctx.lojasWithPlans.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(), _createBlock(_component_Pagination, {
      ref: "pagination",
      key: _ctx.route.path,
      arr: _ctx.lojasWithPlans,
      totalBanco: _ctx.totalLojasWithPlans,
      onPageChanged: _ctx.handlePageChange,
      tipo: 'Planos encontrados'
    }, null, 8, ["arr", "totalBanco", "onPageChanged"])),
    _createVNode(_component_ModalEditPlanoLojaVue, {
      lojaPlanoSelected: _ctx.lojaPlanoSelected,
      closeModal: _ctx.closeModal,
      getAllPlans: _ctx.getAllPlans
    }, null, 8, ["lojaPlanoSelected", "closeModal", "getAllPlans"])
  ]))
}